export const formatUSD = (n) => {
  if (n == null || isNaN(n)) return "—";
  const abs = Math.abs(n);
  if (abs >= 1_000_000_000) return `$${(n / 1_000_000_000).toFixed(2)}B`;
  if (abs >= 1_000_000) return `$${(n / 1_000_000).toFixed(2)}M`;
  if (abs >= 1_000) return `$${(n / 1_000).toFixed(1)}K`;
  return `$${n.toFixed(0)}`;
};

export const formatPct = (n, digits = 0) => {
  if (n == null || isNaN(n)) return "—";
  return `${(n * 100).toFixed(digits)}%`;
};

export const formatSignedPct = (n, digits = 1) => {
  if (n == null || isNaN(n)) return "—";
  const v = n * 100;
  const sign = v > 0 ? "+" : "";
  return `${sign}${v.toFixed(digits)}%`;
};

export const daysUntil = (iso) => {
  if (!iso) return null;
  const t = new Date(iso).getTime();
  if (isNaN(t)) return null;
  const diff = (t - Date.now()) / (1000 * 60 * 60 * 24);
  return diff;
};

export const formatEndDate = (iso) => {
  const d = daysUntil(iso);
  if (d == null) return "—";
  if (d < 0) return "Closed";
  if (d < 1) {
    const hours = Math.max(1, Math.floor(d * 24));
    return `${hours}h left`;
  }
  if (d < 30) return `${Math.floor(d)}d left`;
  if (d < 365) return `${Math.floor(d / 30)}mo left`;
  return `${(d / 365).toFixed(1)}y left`;
};
